<template>
  <div>
    <h3 class="font-weight-bold">Uso e cobertura da terra</h3>
    <span style="font-size: 1.0rem">Últimos dados do uso e cobertura da terra na bacia selecionada.</span>
    <br/><br/>
    <v-row>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="4" md="4">
            <v-card class="primary darken-1 farming">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                </v-col>
                <v-col cols="10">
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }}</span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  icon-infohidro-agropecuaria
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Agropecuária</v-card-subtitle>
              <v-card-text>
                <v-row class="white--text" v-if="!farming">
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold">0 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">0 </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
                <v-row class="white--text" v-else>
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold" v-if="farming.last">{{ calculatePercentage(farming.last) }} </strong>
                    <strong class="display-1 font-weight-bold" v-else>0.00 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">{{ farming.last }} </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <div v-if="farming.last > farming.previous">
                      <v-icon style="color: white" left>mdi-menu-up</v-icon><span style="color: white">Aumentou</span>
                    </div>
                    <div v-else-if="farming.last < farming.previous">
                      <v-icon style="color: white" left>mdi-menu-down</v-icon><span style="color: white">Diminuiu</span>
                    </div>
                    <div v-else-if="farming.last === farming.previous">
                      <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-card class="primary darken-1 forest">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                </v-col>
                <v-col cols="10">
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }}</span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  icon-infohidro-floresta
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Cobertura Florestal</v-card-subtitle>
              <v-card-text>
                <v-row class="white--text" v-if="!forest">
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold">0 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">0 </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
                <v-row class="white--text" v-else>
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold" v-if="forest.last">{{ calculatePercentage(forest.last) }} </strong>
                    <strong class="display-1 font-weight-bold" v-else>0.00 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">{{ forest.last }} </strong>
                    <span> hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <div v-if="forest.last > forest.previous">
                      <v-icon style="color: white" left>mdi-menu-up</v-icon><span style="color: white">Aumentou</span>
                    </div>
                    <div v-else-if="forest.last < forest.previous">
                      <v-icon style="color: white" left>mdi-menu-down</v-icon><span style="color: white">Diminuiu</span>
                    </div>
                    <div v-else-if="forest.last === forest.previous">
                      <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-card class="primary darken-1 naturalFormation">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                </v-col>
                <v-col cols="10">
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }}</span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  icon-infohidro-pantano
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Formação Natural não Florestal</v-card-subtitle>
              <v-card-text>
                <v-row class="white--text" v-if="!naturalFormation">
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold">0 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">0 </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
                <v-row class="white--text" v-else>
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold" v-if="naturalFormation.last">{{ calculatePercentage(naturalFormation.last) }} </strong>
                    <strong class="display-1 font-weight-bold" v-else>0.00 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">{{ naturalFormation.last }} </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <div v-if="naturalFormation.last > naturalFormation.previous">
                      <v-icon style="color: white" left>mdi-menu-up</v-icon><span style="color: white">Aumentou</span>
                    </div>
                    <div v-else-if="naturalFormation.last < naturalFormation.previous">
                      <v-icon style="color: white" left>mdi-menu-down</v-icon><span style="color: white">Diminuiu</span>
                    </div>
                    <div v-else-if="naturalFormation.last === naturalFormation.previous">
                      <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-card class="primary darken-1 notVegetated">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                </v-col>
                <v-col cols="10">
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }}</span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  icon-infohidro-predio
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Área não Vegetada</v-card-subtitle>
              <v-card-text>
                <v-row class="white--text" v-if="!notVegetated">
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold">0 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">0 </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
                <v-row class="white--text" v-else>
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold" v-if="notVegetated.last">{{ calculatePercentage(notVegetated.last) }} </strong>
                    <strong class="display-1 font-weight-bold" v-else>0.00 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">{{ notVegetated.last }} </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <div v-if="notVegetated.last > notVegetated.previous">
                      <v-icon style="color: white" left>mdi-menu-up</v-icon><span style="color: white">Aumentou</span>
                    </div>
                    <div v-else-if="notVegetated.last < notVegetated.previous">
                      <v-icon style="color: white" left>mdi-menu-down</v-icon><span style="color: white">Diminuiu</span>
                    </div>
                    <div v-else-if="notVegetated.last === notVegetated.previous">
                      <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-card class="primary darken-1 waterBodies">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                </v-col>
                <v-col cols="10">
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }}</span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  icon-infohidro-onda
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Corpos d'água</v-card-subtitle>
              <v-card-text>
                <v-row class="white--text" v-if="!waterBodies">
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold">0 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">0 </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{years[years.length-2]}}</strong>.</span>
                  </v-col>
                </v-row>
                <v-row class="white--text" v-else>
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold" v-if="waterBodies.last">{{ calculatePercentage(waterBodies.last) }} </strong>
                    <strong class="display-1 font-weight-bold" v-else>0.00 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold"> {{ waterBodies.last }} </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <div v-if="waterBodies.last > waterBodies.previous">
                      <v-icon style="color: white" left>mdi-menu-up</v-icon><span style="color: white">Aumentou</span>
                    </div>
                    <div v-else-if="waterBodies.last < waterBodies.previous">
                      <v-icon style="color: white" left>mdi-menu-down</v-icon><span style="color: white">Diminuiu</span>
                    </div>
                    <div v-else-if="waterBodies.last === waterBodies.previous">
                      <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{years[years.length-2]}}</strong>.</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-card class="primary darken-1 notObserved">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                </v-col>
                <v-col cols="10">
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }}</span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  icon-infohidro-lupa-cancelado
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Não observado</v-card-subtitle>
              <v-card-text>
                <v-row class="white--text" v-if="!notObserved">
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold">0 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">0 </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
                <v-row class="white--text" v-else>
                  <v-col cols="12" class="align-center justify-center">
                    <strong class="display-1 font-weight-bold" v-if="notObserved.last">{{ calculatePercentage(notObserved.last) }} </strong>
                    <strong class="display-1 font-weight-bold" v-else>0.00 </strong>
                    <span>%</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <strong class="display-0 font-weight-bold">{{ notObserved.last }} </strong>
                    <span>hectares</span>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <div v-if="notObserved.last > notObserved.previous">
                      <v-icon style="color: white" left>mdi-menu-up</v-icon><span style="color: white">Aumentou</span>
                    </div>
                    <div v-else-if="notObserved.last < notObserved.previous">
                      <v-icon style="color: white" left>mdi-menu-down</v-icon><span style="color: white">Diminuiu</span>
                    </div>
                    <div v-else-if="notObserved.last === notObserved.previous">
                      <v-icon style="color: white" left>mdi-minus</v-icon><span style="color: white">Estável</span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="align-center justify-center mt-n4">
                    <span v-if="years">Comparado ao dado do ano de <strong>{{ years[years.length-2] }}</strong>.</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-row align="center" justify="center" class="align-center justify-center">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="primary darken-1 last">
              <v-row class="align-start justify-start ml-2 mr-2">
                <v-col cols="12">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                  <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }} </span>
                  <span style="color: lightgrey; font-size: small" v-else>Atualizado em ##/##/####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="#95A1EC" class="mb-2">
                  mdi-chart-bubble
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Visão geral do uso e cobertura da terra</v-card-subtitle>
              <v-row align="center" justify="center" class="align-center justify-center">
                <v-col cols="1"><span class="transparent" style="color: transparent">.</span></v-col>
                <v-col cols="10" class="align-center justify-center" align-self="center">
                  <land-use-and-land-cover-overview-chart :firstYear="returnFirstYear(years)" :lastYear="returnLastYear(years)" :chart="chart"></land-use-and-land-cover-overview-chart>
                </v-col>
                <v-col cols="1"><span class="transparent" style="color: transparent">.</span></v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LandUseAndLandCoverOverviewChart from "./LandUseAndLandCoverOverviewChart";
export default {
  props:['forest','farming','naturalFormation','notVegetated', 'notObserved','waterBodies','years', 'chart', ],
  name: "LandUseAndCover",
  components: {LandUseAndLandCoverOverviewChart},
  methods:{
    returnFirstYear(years){
      if (years){
        return years[0]
      }
    },
    returnLastYear(years){
      if (years){
        return years[years.length-1]
      }
    },
    calculatePercentage(value){
      let total = this.forest.last + this.farming.last + this.naturalFormation.last + this.notObserved.last + this.notVegetated.last + this.waterBodies.last
      return ((value/total)*100).toFixed(2)
    }
  },
}
</script>

<style scoped>
.last.v-card.v-sheet.theme--dark {
  /*min-height: 582px;*/
  /*min-width: 100%;*/
  /*max-height: 1000px;*/
  /*max-width: 1000px;*/
  /*width: 100%;*/
}
.waterBodies.v-card.v-sheet.theme--dark {
  min-height: 325px;
  /*min-width: 160px;*/
  /*max-height: 325px;*/
  /*max-width: 200px;*/
  width: 100%;
  border-left: 7px solid #4F7EDB !important;
}
.notObserved.v-card.v-sheet.theme--dark {
  min-height: 325px;
  /*min-width: 160px;*/
  /*max-height: 325px;*/
  /*max-width: 200px;*/
  width: 100%;
  border-left: 7px solid #D5D5E5 !important;
}
.notVegetated.v-card.v-sheet.theme--dark {
  min-height: 325px;
  /*min-width: 160px;*/
  /*max-height: 325px;*/
  /*max-width: 200px;*/
  width: 100%;
  border-left: 7px solid #EA9999 !important;
}
.naturalFormation.v-card.v-sheet.theme--dark {
  min-height: 325px;
  /*min-width: 160px;*/
  /*max-height: 325px;*/
  /*max-width: 200px;*/
  width: 100%;
  border-left: 7px solid #5CDF95 !important;
}
.farming.v-card.v-sheet.theme--dark {
  min-height: 325px;
  /*min-width: 160px;*/
  /*max-height: 325px;*/
  /*max-width: 200px;*/
  width: 100%;
  border-left: 7px solid #DBAD40 !important;
}
.forest.v-card.v-sheet.theme--dark {
  min-height: 325px;
  /*min-width: 160px;*/
  /*max-height: 325px;*/
  /*max-width: 200px;*/
  width: 100%;
  border-left: 7px solid #459008 !important;
}
</style>
